import React, { memo } from 'react';
import VideoPlayer from './videojs';

const Video = ({
  source,
  timeoutAction,
  tabChange = false,
  watermark,
  autoplay = true,
  videoRef = null,
  seekButtons = true,
}) => {
  const videoJsOptions = {
    autoplay: true,
    playbackRates: [0.5, 1, 1.25, 1.5, 2],
    controls: true,
    preload: 'auto',
    fluid: true,
    aspectRatio: '1:1',
    userActions: {
      hotkeys: true,
    },
    controlBar: {
      pictureInPictureToggle: false,
      qualitySelector: true,
      fullscreenToggle: true,
    },
    html5: {
      nativeAudioTracks: true,
      nativeVideoTracks: true,
      nativeTextTracks: true,
    },
    sources: [
      {
        src: source,
        type: 'application/x-mpegURL',
        withCredentials: false
      },
    ],
    // sources: [
    //   {
    //     src: source,
    //     type: 'video/mp4',
    //     label: '720P',
    //   },
    //   {
    //     src: source,
    //     type: 'video/mp4',
    //     label: '480P',
    //   },
    //   {
    //     src: source,
    //     type: 'video/mp4',
    //     label: '360P',
    //   },
    // ],
  };

  // const videoJsOptions = {
  //   autoplay: autoplay,
  //   playbackRates: [0.5, 1, 1.25, 1.5, 2],
  //   controls: true,
  //   preload: 'auto',
  //   fluid: true,
  //   aspectRatio: '1:1',
  //   userActions: {
  //     hotkeys: true,
  //   },
  //   controlBar: {
  //     pictureInPictureToggle: false,
  //     qualitySelector: true,
  //     fullscreenToggle: true
  //   },
  //   html5: {
  //     nativeAudioTracks: true,
  //     nativeVideoTracks: true,
  //     nativeTextTracks: true
  //   },
  //   sources: [
  //     {
  //       src: source,
  //       type: 'application/x-mpegURL',
  //       withCredentials: false
  //     },
  //   ],
  // };
  // const videoJsOptions = {
  //   autoplay: true,
  //   playbackRates: [0.5, 1, 1.25, 1.5, 2],
  //   controls: true,
  //   preload: 'auto',
  //   fluid: true,
  //   aspectRatio: '4:3',
  //   userActions: {
  //     hotkeys: true,
  //   },
  //   sources: [
  //     {
  //       src: source,
  //       type: 'video/mp4',
  //       label: '720P',
  //     },
  //     {
  //       src: source,
  //       type: 'video/mp4',
  //       label: '480P',
  //     },
  //     {
  //       src: source,
  //       type: 'video/mp4',
  //       label: '360P',
  //     },
  //   ],
  // };

  return (
    <div className="player">
      <VideoPlayer
        options={videoJsOptions}
        timeoutAction={timeoutAction}
        // videoTime = {videoTime}
        watermark={watermark}
        // videoRef={videoRef}
        seekButtons={seekButtons}
      />
    </div>
  );
};

export default memo(Video);
